var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle120(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 33,
    viewBox: "0 0 194 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 120",
    d: "M0.344833 0H193.656L183.564 15.1388C177.751 23.8582 174.844 28.2178 170.423 30.5843C166.001 32.9508 160.761 32.9508 150.282 32.9508H43.7194C33.2401 32.9508 28.0004 32.9508 23.5786 30.5843C19.1567 28.2178 16.2503 23.8581 10.4374 15.1388L0.344833 0Z",
    fill: "url(#paint0_linear_0_309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_309",
    x1: 98.9991,
    y1: 33,
    x2: 98.9991,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37A9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#385E6F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle120);
export default __webpack_public_path__ + "static/media/Rectangle120.4826f1cba9cb0b7972530cf13c1b8953.svg";
export { ForwardRef as ReactComponent };